/* eslint-disable no-param-reassign */
export const mergeLangObjects = (source, extension) => {
  Object.keys(source).forEach((key) => {
    extension[key] = source[key];
  });

  return extension;
};
